
type Props = {
  to: string;
  text?: string;
}

export const Linky = ({ to, text }: Props) => {
  return <a href={to} target="_blank" rel="noreferrer">{text ?? to}</a>
}
